export function initInfiniteScroll() {
  const container = document.querySelector('#activity-container');
  if (!container) return;  // Ensure we only run on relevant pages

  let page = 2;
  let loading = false;
  let hasNext = true;

  const baseUrl = container.dataset.url || window.location.pathname;

  window.addEventListener('scroll', () => {
    if (loading || !hasNext) return;

    const scrollThreshold = 200;
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - scrollThreshold) {
      loading = true;

      // Use the full current URL as base, then update the page parameter
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('page', page);
      const fetchUrl = currentUrl.pathname + currentUrl.search;

      fetch(fetchUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => response.json())
      .then(data => {
        if (data.html && data.html.trim() !== '') {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.html;
          const newCards = tempDiv.querySelectorAll('.col-12');

          newCards.forEach(card => {
            const cardId = card.getAttribute('data-schedule-id');
            if (!container.querySelector(`[data-schedule-id="${cardId}"]`)) {
              container.appendChild(card);
            }
          });

          page += 1;
          hasNext = data.has_next;
        } else {
          hasNext = false;
        }

        if (!hasNext) {
          const endMessage = document.getElementById('end-of-results');
          if (endMessage) {
            endMessage.style.display = 'block';
          }
        }

        loading = false;
      })
      .catch(err => {
        console.error('Infinite scroll error:', err);
        loading = false;
      });
    }
  });
}
